import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconRules$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconRules extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c1be110474e519f93da200d22ddd1d2455c788d9', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '5efdad101820bb1bb6c4b24e07aaf9e79a9488a0', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a03cbf08f2f3cabc62de8928b5aaf2401e2df08e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7.2 8.88v-.02zm0-.016c-.007-.65-.425-.988-1.06-1.414l-1-.58c-.44-.27-.53-.4-.53-.56S4.82 6 5.12 6h1.55A.3.3 0 0 0 7 5.66V5.3a.3.3 0 0 0-.33-.3H5.11c-1 0-1.65.54-1.65 1.3a1 1 0 0 0 .1.45 1.25 1.25 0 0 0-.76 1.14c0 .66.41 1 1.06 1.42l1 .59c.45.27.54.39.54.55s-.22.34-.52.34H3.33a.3.3 0 0 0-.31.29v.37a.3.3 0 0 0 .31.3h1.56c1 0 1.64-.54 1.64-1.31a1 1 0 0 0-.09-.44c.451-.2.747-.643.76-1.136m-1.14.016a.51.51 0 0 1-.22.41l-.27-.18-1.1-.65c-.48-.29-.54-.41-.54-.59a.56.56 0 0 1 .22-.42l.27.18 1.1.66c.48.28.54.41.54.59m3.44 1.37a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zM9 5.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-.5.5h-9A.5.5 0 0 1 9 6zm.5 10a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V16a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-rules", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-rules"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-rules":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconRules$1);
            }
            break;
    } });
}

const CosmosIconRules = CosmosIconRules$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconRules, defineCustomElement };
